(function () {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name mx.shell:mxView
	 * @module mx.shell
	 * @restrict 'A'
	 * @scope {}
	 * @requires <a href="https://docs.angularjs.org/api/ng/function/angular.element" target="_blank">$element</a>
	 * @requires <a href="https://github.com/angular/material/blob/master/src/core/services/compiler/compiler.js" target="_blank">$mdCompiler</a>
	 * @requires <a href="https://docs.angularjs.org/api/ng/service/$rootScope" target="_blank">$rootScope</a>
	 * @description A directive, main purpose of which is to render and show instance of {@ref mx.shell.View mx.shell.View} or derived types
	 * @usage <div mx-view='vm.instanceOfMxView'></div>
	 */
	angular.module('mx.shell').directive('mxView', function mxViewDirective() {
		ViewController.$inject = ['$scope', '$element', '$mdCompiler'];

		function ViewController($scope, $element, $mdCompiler) {
			var vm = this;
			var currentScope;

			$scope.$watch('vm.mxView', function () {
				if (vm.mxView) {
					init();
				}
			});

			function init() {
				// TODO: Why do we need `initView`  at all here ???
				if (typeof vm.mxView.initView === 'function') {
					// TODO: What `vm.mxView.locals.selectedObjects` is doing inside `mxView` ???
					// TODO: Why don't do it inside of corresponding control??? or at least inside of Wizard View ???
					vm.mxView.initView(vm.mxView.locals.selectedObjects).then(function (newData) {
						vm.mxView.locals = angular.extend(vm.mxView.locals, newData);
						compileView();
					});
				} else {
					compileView();
				}
			}

			function compileView() {
				if (currentScope) {
					currentScope.$destroy();
				}

				$mdCompiler.compile(vm.mxView).then(function (compileData) {
					currentScope = $scope.$new(true);

					$element.html(compileData.element);
					compileData.link(currentScope);
				});
			}
		}

		return {
			restrict: 'A',
			scope: {},
			bindToController: { mxView: '<' },
			controller: ViewController,
			controllerAs: 'vm',
		};
	});
})();
